import { useRef, useEffect, useState } from 'react'
import '../styles.css'
import { Helmet } from "react-helmet";
import { apiUrl } from "../constants";
import axios from "axios";
import { Box, Grid, Card, Container, TextField, Typography, useTheme, Button } from "@mui/material";
import { tokens } from "../theme";
import { useSelector } from 'react-redux';
import useCheckToken from '../hooks/useCheckToken';
import useExchangeToken from "../hooks/useExchangeToken";
import db from "../firebase-config";
import LensIcon from '@mui/icons-material/Lens';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import authorize from '../assets/img/authorize.png';
import { useParams } from 'react-router-dom';
import moment from 'moment-timezone';



const CorrelationP2 = () => {
    const { bu, plant, factory, line } = useParams();
    const exchangeToken = useExchangeToken();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const today = new Date();
    const hourago = new Date(today.getTime());
    const datetime = moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');

    const [seleteUserName, setSeleteUserName] = useState(null);
    const [seleteAuthorize, setSeleteAuthorize] = useState(null);
    const [openConfirmChangeAuthorize, setOpenConfirmChangeAuthorize] = useState();
    const [unlockSuccessful, setUnlockSuccessful] = useState();
    const [notifySubmittedUnlockSuccessful, setNotifySubmittedUnlockSuccessful] = useState(false);
    const [notifySubmittedUnlockFailed, setNotifySubmittedUnlockFailed] = useState(false);


    const [seleteNote, setSeleteNote] = useState(null);
    const [enable_giveaway, setEnable_giveaway] = useState([]);
    const [error, setError] = useState(null);
    const [isTokenExchanged, setIsTokenExchanged] = useState(false);

    useCheckToken();
    const ac_token = useSelector(state => state.auth.access_token);
    const display = useSelector(state => state.auth.email);
    const name = useSelector(state => state.auth.display);


    const handleClickConfirmChangeAuthorize = () => {
        setOpenConfirmChangeAuthorize(true);
    };

    const handleCloseConfirmChangeAuthorize = () => {
        setOpenConfirmChangeAuthorize(false);
    };


    const handleSelectionInUnlockform = (event) => {
        if (event.target.name === "user") {
            setSeleteUserName(event.target.value);
        }
        if (event.target.name === "status") {
            setSeleteAuthorize(event.target.value);
        }
        if (event.target.name === "note") {
            setSeleteNote(event.target.value);
        }
    };


    useEffect(() => {
        const fetchInitialTokenAndData = async () => {
            try {
                const token = await exchangeToken(); // ตรวจสอบหรือแลกเปลี่ยนโทเค็น
                if (token) {
                    setIsTokenExchanged(true); // ระบุว่าโทเค็นพร้อม
                }
            } catch (err) {
                console.error("Error exchanging token:", err);
                setError("Failed to exchange token");
            }
        };

        fetchInitialTokenAndData();
    }, [exchangeToken]);

    // const line_giveaway = () => {
    //     try {
    //         const buName = bu;
    //         const plantName = plant;
    //         const factoryName = factory;
    //         const lineName = line;
    //         const lineMapping = {
    //             "แปรรูปไก่_4117_FPP2_Line7": 'Simulator.4117.00000000000000.Thailand.Dashboard.GiveAway.Line7',
    //             "แปรรูปไก่_4117_FPP2_Line8": 'Simulator.4117.00000000000000.Thailand.Dashboard.GiveAway.Line8',
    //             "แปรรูปไก่_4117_FPP2_Line9": 'Simulator.4117.00000000000000.Thailand.Dashboard.GiveAway.Line9',
    //             "แปรรูปไก่_4117_FPP2_Line10": 'Simulator.4117.00000000000000.Thailand.Dashboard.GiveAway.Line10',

    //             "แปรรูปไก่_4116_PlantB_Line4": 'Simulator.4116.00000000000000.Thailand.Dashboard.GiveAway.Line4',
    //             "แปรรูปไก่_4116_PlantB_Line5": 'Simulator.4116.00000000000000.Thailand.Dashboard.GiveAway.Line5',
    //         };
    //         const key = `${buName}_${plantName}_${factoryName}_${lineName}`;
    //         return lineMapping[key];
    //     } catch (error) {
    //         console.error("Error in line_performance:", error);
    //         return null;
    //     }
    // };

    // const line_giveaway_sentapi = () => {
    //     try {
    //         const buName = bu;
    //         const plantName = plant;
    //         const factoryName = factory;
    //         const lineName = line;
    //         const lineMapping = {
    //             "แปรรูปไก่_4117_FPP2_Line7": 'LINE7',
    //             "แปรรูปไก่_4117_FPP2_Line8": 'LINE8',
    //             "แปรรูปไก่_4117_FPP2_Line9": 'LINE9',
    //             "แปรรูปไก่_4117_FPP2_Line10": 'LINE10',
    //         };
    //         const key = `${buName}_${plantName}_${factoryName}_${lineName}`;
    //         return lineMapping[key];
    //     } catch (error) {
    //         console.error("Error in line_performance:", error);
    //         return null;
    //     }
    // };


    const handleUnlock = async () => {
        // console.log({
        //     "plant_id": plant,
        //     "factory": factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory,
        //     "line": line,
        //     "user": display,
        //     "status": get_enable?.VALUE == true ? false : true,
        //     "note": seleteNote,
        //     "timestamp": datetime,
        //     "country": plant === 'B425' ? 'Vietnam' : 'Thailand'
        // })
        await axios.post(apiUrl.UNLOCK_GIVEAWAY, {
            "plant_id": plant,
            "factory": factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory,
            "line": line,
            "user": display,
            "status": get_enable?.VALUE == true ? false : true,
            "note": seleteNote,
            "timestamp": datetime,
            "country": plant === 'B425' ? 'Vietnam' : 'Thailand'
        }, {
            headers: {
                Authorization: `Bearer ${ac_token}`,
            },
        })
            .then(response => {
                // console.log(response)
                if (response.status == 200) {
                    setSeleteUserName();
                    setSeleteAuthorize();
                    setSeleteNote();
                    setUnlockSuccessful(1)
                    setNotifySubmittedUnlockSuccessful(true);
                }
                else {
                    setUnlockSuccessful(2)
                    setNotifySubmittedUnlockFailed(true);
                }
            })
            .catch(error => {
                console.log('unlock error: ', error);
            })
    }

    useEffect(() => {
        const subscriberUnlock = db
            .collection("prod_mes_ignition_giveaway_tag_list")
            .where("TAG", "==", `Simulator.${plant}.${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}.${plant === 'B425' ? 'Vietnam' : 'Thailand'}.Dashboard.GiveAway.${line}.PI_Cloud_Enable`)
            .onSnapshot((querySnapshot) => {
                const unlockData = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                setEnable_giveaway(unlockData);
            });

        // Cleanup listeners
        return () => {
            subscriberUnlock();
        };
    }, []);

    const get_enable = enable_giveaway.find((tag) => tag.TAG.includes(`Simulator.${plant}.${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}.${plant === 'B425' ? 'Vietnam' : 'Thailand'}.Dashboard.GiveAway.${line}.PI_Cloud_Enable`));



    return (
        <Box>
            <Helmet>
                <title>UnlockGiveaway Page2 | MES</title>
            </Helmet>
            <Grid container spacing={0}>
                {/* Top row display date */}
                <Grid xs={12} >
                    <Box>
                        <Typography style={{ color: "#000000", fontWeight: "bold", fontSize: "30px", position: "relative", paddingLeft: 0, paddingTop: 10 }} textAlign="center">
                            {get_enable?.VALUE == true ? 'ปิดการใช้งาน Giveaway' : 'เปิดการใช้งาน Giveaway'}
                        </Typography>
                        <Typography style={{ position: "relative", paddingLeft: 0, paddingTop: 10 }} textAlign="center">
                            <img src={authorize} height="150px" />
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                            <Typography style={{ color: "#000000", fontWeight: "bold", fontSize: "24px", position: "relative", paddingLeft: 0, paddingTop: 10 }} textAlign="center">
                                {line}: &nbsp;
                            </Typography>
                            <Typography style={{ fontWeight: "bold", fontSize: "24px", position: "relative", left: 0, paddingTop: 10 }} textAlign="center">
                                <LensIcon fontSize="medium" stroke={get_enable?.VALUE == true ? '#00d084' : '#9e9e9e'} strokeWidth="2" sx={{ color: get_enable?.VALUE == true ? '#00d084' : '#9e9e9e' }} style={{ position: "relative", paddingLeft: 0, top: 5 }}></LensIcon>
                                &nbsp;{get_enable?.VALUE == true ? 'เปิดการใช้งาน' : 'ปิดการใช้งาน'}
                            </Typography>
                        </Box>
                    </Box>

                    <Box>
                        <Typography style={{ fontSize: '16px', fontWeight: 'medium', paddingLeft: 0, paddingTop: 15 }} textAlign="left">
                            ชื่อ
                        </Typography>
                        <TextField
                            //required
                            id="outlined-required"
                            //type="number"
                            name="user"
                            value={name}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={handleSelectionInUnlockform}
                            sx={{ width: '100%' }}
                        />
                    </Box>

                    <Box>
                        <Typography style={{ fontSize: '16px', fontWeight: 'medium', paddingLeft: 0, paddingTop: 20 }} textAlign="left">
                            การใช้งาน
                        </Typography>
                        <TextField
                            //required
                            id="outlined-required"
                            //type="number"
                            name="status"
                            value={get_enable?.VALUE == true ? 'ปิดการใช้งาน' : 'เปิดการใช้งาน'}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={handleSelectionInUnlockform}
                            sx={{ width: '100%' }}
                        />
                    </Box>

                    <Box>
                        <Typography style={{ fontSize: '16px', fontWeight: 'medium', position: "relative", paddingLeft: 0, paddingTop: 20 }} textAlign="left">
                            {get_enable?.VALUE == true ? 'เหตุผลที่ต้องการปิดการใช้งาน' : 'เหตุผลที่ต้องการเปิดการใช้งาน'}
                        </Typography>
                        <TextField
                            //required
                            id="outlined-required"
                            //type="number"
                            name="note"
                            value={seleteNote}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={handleSelectionInUnlockform}
                            sx={{ width: '100%' }}
                        />
                    </Box>

                    <Box style={{ position: "relative", paddingLeft: 0, paddingTop: 30 }}>
                        <Button disabled={!seleteNote} fullWidth style={{ fontSize: '16px', fontWeight: "bold", backgroundColor: !seleteNote ? '#cfcfcf' : '#3cbea8' }} variant="contained" onClick={() => { handleClickConfirmChangeAuthorize(); }}>ยืนยัน</Button>
                    </Box>
                </Grid>
            </Grid>

            {/* pop up start tumbler  */}
            <Dialog
                open={openConfirmChangeAuthorize}
                onClose={handleCloseConfirmChangeAuthorize}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    ยืนยัน
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {get_enable?.VALUE == true ? 'ปิดการใช้งาน Giveaway?' : 'เปิดการใช้งาน Giveaway?'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button style={{ minWidth: '110px', backgroundColor: '#575755' }} variant="contained" onClick={() => { setOpenConfirmChangeAuthorize(false); }}>ยกเลิก</Button>
                    <Button style={{ minWidth: '110px', backgroundColor: '#009688' }} variant="contained" onClick={() => { setOpenConfirmChangeAuthorize(false); handleUnlock(); }}>ยืนยัน</Button>
                </DialogActions>
            </Dialog>

            {unlockSuccessful == 1 ?
                <div style={{ marginTop: 20 }}>
                    <Dialog
                        open={notifySubmittedUnlockSuccessful}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" minWidth='200px' align='center'>
                                {get_enable?.VALUE == true ? 'ปิดการใช้งาน Giveaway สำเร็จ' : 'เปิดการใช้งาน Giveaway สำเร็จ'}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button style={{ backgroundColor: '#009688' }} variant="contained" onClick={() => { setNotifySubmittedUnlockSuccessful(false); window.location.reload(false); }}>OK</Button>
                        </DialogActions>
                    </Dialog>

                </div>
                : console.log()
            }

            {unlockSuccessful == 2 ?
                <div style={{ marginTop: 20 }}>
                    <Dialog
                        open={notifySubmittedUnlockFailed}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" minWidth='200px' align='center'>
                                เกิดข้อผิดพลาด!!!, โปรดลองใหม่อีกครั้ง
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button style={{ backgroundColor: '#009688' }} aligh='Center' variant="contained" onClick={() => { setNotifySubmittedUnlockFailed(false); }}>OK</Button>
                        </DialogActions>
                    </Dialog>
                </div>
                : console.log()
            }
        </Box>
    )
}

export default CorrelationP2
